export default __webpack_public_path__ + "static/media/workout-body.09649c7c.png";